import { camo } from './camo';
import { modern } from './modern';
import { patriotic } from './patriotic';
import { throwback } from './throwback';
import { traditional } from './traditional';
// import { vintage } from './vintage';
import { awareness } from './awareness';
import { minor_league } from './minor_league';
import { pinstripe } from './pinstripe';
import { flannel } from './flannel';
import { triton_connect } from './triton_connect';

export const baseball = {
  traditional,
  throwback,
  modern,
  pinstripe,
  flannel,
  patriotic,
  camo,
  // vintage,
  awareness,
  minor_league,
  triton_connect,
};
